"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutorialStepsHelper = void 0;
class TutorialStepsHelper {
    static addStep() {
        console.log('[TutorialStepsHelper addStep] called, current steps:', this.steps.length);
        const newStep = {
            title: '',
            description: '',
            order: this.steps.length + 1,
            sections: []
        };
        // Create new array reference to trigger reactivity
        this.steps = [...this.steps, newStep];
        console.log('[TutorialStepsHelper addStep] steps array updated:', this.steps.length);
        // Add a default section to the new step
        this.addSectionToStep(this.steps.length - 1);
    }
    static removeStep(stepIndex) {
        if (!this.steps || this.steps.length <= 1) {
            return; // Don't remove if only one step or no steps
        }
        this.steps = this.steps.filter((_, i) => i !== stepIndex);
        this.steps = this.steps.map((step, i) => ({ ...step, order: i + 1 }));
    }
    static moveStepUp(stepIndex) {
        if (!this.steps || stepIndex <= 0) {
            return;
        }
        const steps = [...this.steps];
        [steps[stepIndex - 1], steps[stepIndex]] = [steps[stepIndex], steps[stepIndex - 1]];
        steps.forEach((step, index) => {
            step.order = index + 1;
        });
        this.steps = steps;
    }
    static moveStepDown(stepIndex) {
        if (!this.steps || stepIndex < 0 || stepIndex >= this.steps.length - 1) {
            return;
        }
        const steps = [...this.steps];
        [steps[stepIndex], steps[stepIndex + 1]] = [steps[stepIndex + 1], steps[stepIndex]];
        steps.forEach((step, index) => {
            step.order = index + 1;
        });
        this.steps = steps;
    }
    static updateStepField(stepIndex, field, value) {
        if (!this.steps) {
            this.steps = [];
            return;
        }
        if (stepIndex < 0 || stepIndex >= this.steps.length) {
            return;
        }
        const step = this.steps[stepIndex];
        if (!step) {
            return;
        }
        if (!step.sections) {
            step.sections = [];
        }
        step[field] = value;
        this.steps = [...this.steps];
    }
    static updateSectionField(stepIndex, sectionIndex, field, value) {
        if (!this.steps) {
            this.steps = [];
            return;
        }
        if (stepIndex < 0 || stepIndex >= this.steps.length) {
            return;
        }
        const step = this.steps[stepIndex];
        if (!step) {
            return;
        }
        if (!step.sections) {
            step.sections = [];
        }
        if (sectionIndex < 0 || sectionIndex >= step.sections.length) {
            return;
        }
        const section = step.sections[sectionIndex];
        if (!section) {
            return;
        }
        if (field === 'title') {
            section.title = value;
        }
        else if (field === 'description') {
            section.description = value;
        }
        else if (field === 'prompt') {
            section.prompt = value;
        }
        else if (field === 'screenshot') {
            section.screenshot = value; // File object or null
        }
        else if (field === 'video') {
            section.video = value; // File object or null
        }
        else if (field === 'screenshotMini') {
            section.screenshotMini = value;
        }
        else if (field === 'videoMini') {
            section.videoMini = value;
        }
        else if (field === 'sourceFrom') {
            section.sourcePagesFrom = value !== '' && value != null ? Number(value) : null;
        }
        else if (field === 'sourceTo') {
            section.sourcePagesTo = value !== '' && value != null ? Number(value) : null;
        }
        else if (field === 'sourceText') {
            section.sourceText = value;
        }
        else {
            return;
        }
        this.steps = [...this.steps];
    }
    static addSectionToStep(stepIndex) {
        if (!this.steps) {
            this.steps = [];
            return;
        }
        if (stepIndex < 0 || stepIndex >= this.steps.length) {
            return;
        }
        const step = this.steps[stepIndex];
        if (!step) {
            return;
        }
        if (!step.sections) {
            step.sections = [];
        }
        const sectionIndex = step.sections.length;
        const newSection = {
            title: '',
            description: '',
            prompt: '',
            order: sectionIndex + 1,
            knowledgeIds: [],
            screenshot: null,
            video: null,
            screenshotMini: null,
            videoMini: null,
            tutorialSectionFiles: [],
            todoItems: [],
            formData: ''
        };
        step.sections = [...step.sections, newSection];
        this.steps = this.steps.map((s, i) => i === stepIndex ? { ...s } : s);
        setTimeout(() => {
            var _a;
            const slide = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.tutorial-form-slide.slide-step[active]');
            const sectionEl = slide === null || slide === void 0 ? void 0 : slide.querySelector(`.section-edit[data-section-index="${sectionIndex}"]`);
            sectionEl === null || sectionEl === void 0 ? void 0 : sectionEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            const titleInput = sectionEl === null || sectionEl === void 0 ? void 0 : sectionEl.querySelector('.section-title-part input');
            titleInput === null || titleInput === void 0 ? void 0 : titleInput.focus({ preventScroll: true });
        }, 0);
    }
    static removeSectionFromStep(stepIndex, sectionIndex) {
        if (!this.steps || stepIndex < 0 || stepIndex >= this.steps.length) {
            return;
        }
        const step = this.steps[stepIndex];
        if (!step.sections || step.sections.length <= 1) {
            return;
        }
        step.sections = step.sections.filter((_, i) => i !== sectionIndex);
        step.sections = step.sections.map((section, i) => ({ ...section, order: i + 1 }));
        this.steps = [...this.steps];
    }
    static moveSectionUp(stepIndex, sectionIndex) {
        if (!this.steps || stepIndex < 0 || stepIndex >= this.steps.length || sectionIndex <= 0) {
            return;
        }
        const step = this.steps[stepIndex];
        if (!step.sections || sectionIndex >= step.sections.length) {
            return;
        }
        const sections = [...step.sections];
        [sections[sectionIndex - 1], sections[sectionIndex]] = [sections[sectionIndex], sections[sectionIndex - 1]];
        sections.forEach((section, index) => {
            section.order = index + 1;
        });
        step.sections = sections;
        this.steps = [...this.steps];
    }
    static moveSectionDown(stepIndex, sectionIndex) {
        if (!this.steps || stepIndex < 0 || stepIndex >= this.steps.length) {
            return;
        }
        const step = this.steps[stepIndex];
        if (!step.sections || sectionIndex < 0 || sectionIndex >= step.sections.length - 1) {
            return;
        }
        const sections = [...step.sections];
        [sections[sectionIndex], sections[sectionIndex + 1]] = [sections[sectionIndex + 1], sections[sectionIndex]];
        sections.forEach((section, index) => {
            section.order = index + 1;
        });
        step.sections = sections;
        this.steps = [...this.steps];
    }
    static handleSectionKnowledgeChange(stepIndex, sectionIndex, knowledgeIds) {
        if (!this.steps || stepIndex < 0 || stepIndex >= this.steps.length) {
            return;
        }
        const step = this.steps[stepIndex];
        if (sectionIndex >= 0 && sectionIndex < step.sections.length) {
            step.sections[sectionIndex].knowledgeIds = knowledgeIds;
        }
    }
    static getSectionsForStep(stepIndex) {
        if (!this.steps || stepIndex < 0 || stepIndex >= this.steps.length) {
            return [];
        }
        const step = this.steps[stepIndex];
        if (!step) {
            return [];
        }
        if (!step.sections) {
            step.sections = [];
        }
        return step.sections;
    }
    static handleSectionFileChange(stepIndex, sectionIndex, fileType, file) {
        if (!this.steps || stepIndex < 0 || stepIndex >= this.steps.length) {
            return;
        }
        const step = this.steps[stepIndex];
        if (!step || !step.sections || sectionIndex < 0 || sectionIndex >= step.sections.length) {
            return;
        }
        step.sections[sectionIndex][fileType] = file;
        this.steps = [...this.steps];
    }
    static addTodoItem(stepIndex, sectionIndex) {
        const step = this.steps[stepIndex];
        const section = step === null || step === void 0 ? void 0 : step.sections[sectionIndex];
        if (!step || !section) {
            return;
        }
        if (!section.todoItems) {
            section.todoItems = [];
        }
        const todoIndex = section.todoItems.length;
        const newTodoItem = {
            title: '',
            description: '',
            done: false,
            order: todoIndex + 1
        };
        TutorialStepsHelper.replaceSectionTodos.call(this, stepIndex, sectionIndex, [...section.todoItems, newTodoItem]);
        setTimeout(() => {
            var _a;
            const slide = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.tutorial-form-slide.slide-step[active]');
            const todoInput = slide === null || slide === void 0 ? void 0 : slide.querySelector(`.section-edit[data-section-index="${sectionIndex}"] .task-edit[data-task="${todoIndex}"] input`);
            todoInput === null || todoInput === void 0 ? void 0 : todoInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            todoInput === null || todoInput === void 0 ? void 0 : todoInput.focus({ preventScroll: true });
        }, 0);
    }
    static removeTodoItem(stepIndex, sectionIndex, todoIndex) {
        var _a;
        const section = (_a = this.steps[stepIndex]) === null || _a === void 0 ? void 0 : _a.sections[sectionIndex];
        if (!section || !section.todoItems) {
            return;
        }
        const newTodoItems = [...section.todoItems];
        newTodoItems.splice(todoIndex, 1);
        newTodoItems.forEach((item, index) => {
            item.order = index + 1;
        });
        TutorialStepsHelper.replaceSectionTodos.call(this, stepIndex, sectionIndex, newTodoItems);
    }
    static updateTodoItem(stepIndex, sectionIndex, todoIndex, field, value) {
        var _a;
        const section = (_a = this.steps[stepIndex]) === null || _a === void 0 ? void 0 : _a.sections[sectionIndex];
        if (!section || !section.todoItems || !section.todoItems[todoIndex]) {
            return;
        }
        const updatedTodoItem = { ...section.todoItems[todoIndex] };
        updatedTodoItem[field] = value;
        const newTodoItems = [...section.todoItems];
        newTodoItems[todoIndex] = updatedTodoItem;
        TutorialStepsHelper.replaceSectionTodos.call(this, stepIndex, sectionIndex, newTodoItems);
    }
    // Replaces every level of the step -> section -> todos chain with new objects to ensure reactivity
    static replaceSectionTodos(stepIndex, sectionIndex, todoItems) {
        const step = this.steps[stepIndex];
        const section = step.sections[sectionIndex];
        const newSections = [...step.sections];
        newSections[sectionIndex] = { ...section, todoItems };
        const newSteps = [...this.steps];
        newSteps[stepIndex] = { ...step, sections: newSections };
        this.steps = newSteps;
    }
    static getAllSectionsFlat() {
        const result = [];
        this.steps.forEach((step, stepIndex) => {
            step.sections.forEach((section, sectionIndex) => {
                result.push({ section, stepIndex, sectionIndex });
            });
        });
        return result;
    }
    static scrollToStep(stepIndex) {
        // Steps are now in a carousel; update currentStepIndex to slide into view
        // stepIndex is 0-based for actual steps, carousel slide is stepIndex + 1
        if (stepIndex >= 0 && stepIndex < this.steps.length) {
            this.currentStepIndex = stepIndex + 1;
        }
    }
    static scrollToSection(sectionIndex) {
        var _a;
        const slide = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.tutorial-form-slide.slide-step[active]');
        const sectionEl = slide === null || slide === void 0 ? void 0 : slide.querySelector(`.section-edit[data-section-index="${sectionIndex}"]`);
        sectionEl === null || sectionEl === void 0 ? void 0 : sectionEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    static renderSectionSourceHtml() {
        setTimeout(() => {
            var _a;
            const containers = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.section-source-content');
            containers === null || containers === void 0 ? void 0 : containers.forEach((container) => {
                var _a, _b;
                const stepIndex = container.getAttribute('data-step-index');
                const sectionIndex = container.getAttribute('data-section-index');
                if (stepIndex === null || sectionIndex === null) {
                    return;
                }
                const section = (_b = (_a = this.steps[Number(stepIndex)]) === null || _a === void 0 ? void 0 : _a.sections) === null || _b === void 0 ? void 0 : _b[Number(sectionIndex)];
                container.innerHTML = (section === null || section === void 0 ? void 0 : section.sourceText) ? section.sourceText : '';
            });
        }, 0);
    }
}
exports.TutorialStepsHelper = TutorialStepsHelper;
